"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Balloons = exports.Balloon = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = _interopRequireDefault(require("@mojs/core"));

var _utils = require("./utils");

var _Balloon = require("./Balloon.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Balloon = function Balloon(_ref) {
  var msgText = _ref.msgText,
      colors = _ref.colors,
      popVolumeLevel = _ref.popVolumeLevel,
      loop = _ref.loop,
      hangOnTop = _ref.hangOnTop,
      supportsTouch = _ref.supportsTouch;
  var delay = (0, _utils.random)(0, 4);
  var hasMsg = (0, _utils.random)(0, 2);
  var duration = 10 + (0, _utils.random)(1, 5);
  var left = (0, _utils.random)(10, 70); // random init left value to fly

  var _useState = (0, _react.useState)(true),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      visible = _useState4[0],
      setVisible = _useState4[1];

  var audio = new Audio('https://soundbible.com/mp3/Balloon%20Popping-SoundBible.com-1247261379.mp3');
  audio.volume = popVolumeLevel;

  var popBalloon = function popBalloon(e) {
    var t = e.currentTarget;
    var color = t.getAttribute('color');
    var burst = new _core["default"].Burst({
      radius: {
        30: 100
      },
      parent: t,
      count: 10,
      className: 'show',
      children: {
        fill: [color],
        angle: {
          0: 180
        },
        delay: 'stagger(0, 25)',
        shape: ['circle', 'polygon']
      }
    });
    audio.play();
    burst.replay(); // setVisible(false)

    t.style.visibility = 'hidden';
    setTimeout(function () {
      setShow(false);
    }, 2000);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, show ? /*#__PURE__*/_react["default"].createElement(_Balloon.StyledBalloon, {
    color: (0, _utils.randomColor)(colors),
    onClick: supportsTouch ? popBalloon : null,
    onDoubleClickCapture: supportsTouch ? null : popBalloon,
    animate: {
      delay: delay,
      duration: duration,
      rotate: (0, _utils.random)(20, 25),
      left: left,
      loop: loop,
      hangOnTop: hangOnTop
    },
    show: show,
    visible: visible
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "string"
  }), hasMsg ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "msg"
  }, msgText) : null) : null);
};

exports.Balloon = Balloon;

var Balloons = function Balloons(_ref2) {
  var count = _ref2.count,
      msgText = _ref2.msgText,
      colors = _ref2.colors,
      popVolumeLevel = _ref2.popVolumeLevel,
      loop = _ref2.loop,
      hangOnTop = _ref2.hangOnTop;
  var density = count; // concurrent balloon count

  var supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "set-of-balloons"
  }, new Array(density).fill(null).map(function (b, i) {
    return /*#__PURE__*/_react["default"].createElement(Balloon, {
      key: "balloon-".concat(i),
      msgText: msgText,
      colors: colors,
      popVolumeLevel: popVolumeLevel,
      loop: loop,
      hangOnTop: hangOnTop,
      supportsTouch: supportsTouch
    });
  }));
};

exports.Balloons = Balloons;